import { useInView } from '@/hooks/useInView';

const items = [
  { num: '01', text: 'Educational robot for children from 5 to 12 years old' },
  { num: '02', text: 'Educational programs for schools and kindergartens' },
  { num: '03', text: 'Textbooks and exercises for learning', yellow: true },
  { num: '04', text: 'More than 30 variants of robot transformations' },
];

export default function NanitPackage() {
  const { ref, inView } = useInView();

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-500 mb-3">What's Included</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 font-syne">Nanit Package</h2>
        </div>

        <div className={`relative rounded-3xl overflow-hidden transition-all duration-700 delay-100 ${inView ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          <img
            src="https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/%D0%A3%D0%BD%D1%96%D0%BA%D0%B0%D0%BB%D1%8C%D0%BD%D1%96%D1%81%D1%82%D1%8C_6-1.jpg"
            alt="Nanit package contents"
            className="w-full h-[420px] md:h-[520px] object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/30 to-transparent"></div>

          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {items.map((item, i) => (
                <div
                  key={item.num}
                  className={`rounded-xl p-4 md:p-5 transition-all duration-500 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'} ${item.yellow ? 'bg-yellow-400' : 'bg-white/90 backdrop-blur-sm'}`}
                  style={{ transitionDelay: `${200 + i * 100}ms` }}
                >
                  <span className="text-2xl font-extrabold text-gray-900 font-syne block mb-1">{item.num}.</span>
                  <p className="text-xs font-medium text-gray-800 leading-snug">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-700 delay-500 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <a
            href="#offers"
            onClick={(e) => { e.preventDefault(); document.getElementById('offers')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-block bg-yellow-400 text-gray-900 font-bold px-8 py-3.5 rounded-full hover:bg-yellow-300 transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            View Offers
          </a>
        </div>
      </div>
    </section>
  );
}
